<div
  *ngIf="isEligibleForIntercomChat && !intercomChatOpen"
  class="intercom-chat-nudge"
  [ngClass]="{ 'intercom-chat-nudge-open': isOpenState }"
>
  <div class="intercom-chat-nudge-inner">
    <button (click)="openIntercomChat()">
      <span> Do you need help? </span>
      <span> Chat with us! </span>
    </button>
  </div>
</div>
